<template>
    <div>
        <div v-if="initialData !== ''">
            <img
                :src="initialData"
                class="border-1 surface-border h-[150px] w-[150px]"
            />
            <div class="flex gap-2">
                <prime-button
                    severity="secondary"
                    outlined
                    @click="display = true"
                >
                    {{ t('purchaseContract.documentSection.changeInitials') }}
                </prime-button>

                <inline-message
                    v-if="invalidData"
                    class="js-RequiredFormInput"
                >
                    {{
                        t(
                            'purchaseContract.documentSection.initialsMissingWarning'
                        )
                    }}
                </inline-message>
            </div>
        </div>

        <div
            v-else
            class="flex gap-2"
        >
            <prime-button @click="display = true">
                {{ t('purchaseContract.documentSection.clickToInitial') }}
            </prime-button>

            <inline-message
                v-if="showErrors"
                class="js-RequiredFormInput"
            >
                {{
                    t(
                        'purchaseContract.documentSection.initialsRequiredWarning'
                    )
                }}
            </inline-message>
        </div>

        <prime-dialog
            v-model:visible="display"
            :header="t('purchaseContract.documentSection.initials')"
            :modal="true"
            :pt="{
                root: {
                    class: 'w-full h-max-md:h-full max-h-full !rounded-none md:h-auto md:!w-[450px]'
                },
                header: {
                    class: '!dark:bg-slate-800 !bg-slate-100 !rounded-none'
                },
                content: {
                    class: '!dark:bg-slate-800 !bg-slate-100 !rounded-none flex-1'
                },
                footer: {
                    class: '!dark:bg-slate-800 !bg-slate-100 !rounded-none'
                }
            }"
            :pt-options="{
                mergeProps: true
            }"
        >
            <app-signature-pad
                canvas-class="h-[300px] w-[300px]"
                :help-text="t('purchaseContract.documentSection.initialsHelp')"
                @data="handleUpdateInitialData"
            />

            <template #footer>
                <div class="space-x-4">
                    <prime-button
                        :label="t('cancel')"
                        text
                        @click="handleCancel"
                    />

                    <prime-button
                        :label="t('ok')"
                        icon="pi pi-check"
                        :disabled="currentData === ''"
                        @click="handleOk"
                    />
                </div>
            </template>
        </prime-dialog>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import PrimeButton from 'primevue/button'
import PrimeDialog from 'primevue/dialog'
import AppSignaturePad from '~/components/ContentTemplate/AppSignaturePad.vue'
import InlineMessage from 'primevue/inlinemessage'
import { useI18n } from 'vue-i18n'

const props = defineProps({
    initialData: {
        type: String,
        required: true
    },
    showErrors: {
        type: Boolean,
        required: true
    },
    invalidData: {
        type: Boolean,
        required: true
    }
})

const emit = defineEmits({
    'update:initialData': (payload: string) => typeof payload === 'string'
})

const { t } = useI18n({ useScope: 'global' })
const display = ref(false)
const currentData = ref(props.initialData)

function handleUpdateInitialData(data: string) {
    currentData.value = data
}

function handleOk() {
    emit('update:initialData', currentData.value)
    display.value = false
}

function handleCancel() {
    display.value = false
}
</script>
